export const cssUrl = (filename) =>
  `/static/reactcss/${filename}?v=${(window.__ASSET_V__ || {})[filename] || 0}`;